import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MarketRegionFilterComponent } from '../components/market-region-filter/market-region-filter.component';
import { CompareDialogComponent } from '../components/compare-dialog/compare-dialog.component';
import { DatePickerDialogComponent } from '../components/date-picker-dialog/date-picker-dialog.component';
import { NewUserDialogComponent } from '../../features/admin/new-user-dialog/new-user-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  defaultDialogOptions = {
    width: '900px',
    maxWidth: '90vw',
    autoFocus: false,
  };

  constructor(private _dialog: MatDialog) {}
  openDateRangePicker(dialogOptions: any = null) {
    dialogOptions = dialogOptions || this.defaultDialogOptions;

    return this._dialog.open(DatePickerDialogComponent, dialogOptions);
  }

  openFilterDialog(dialogOptions: any = null) {
    dialogOptions = dialogOptions || {
      width: '950px',
      maxWidth: '90vw',
      autoFocus: false,
    };

    return this._dialog.open(MarketRegionFilterComponent, dialogOptions);
  }

  openCompareDialog(ta: string, element: string, dialogOptions: any = null) {
    dialogOptions = dialogOptions || this.defaultDialogOptions;

    return this._dialog.open(CompareDialogComponent, {
      ...dialogOptions,
      data: { ta, element },
    });
  }

  openNewUserDialog(dialogOptions: any = null) {
    dialogOptions = dialogOptions || this.defaultDialogOptions;

    return this._dialog.open(NewUserDialogComponent, dialogOptions);
  }
}
